/**
 * Created by Shikha Gupta on 2021/04/26.
 */

import {ISymbolStateConfig, SymbolStateTransition} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineLite, TweenLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {HorribleHerosScatterWildymbol} from "./HorribleHerosScatterWildymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";

export class TrailingWildSymbol extends HorribleHerosScatterWildymbol {

    protected _trailOverlay: PIXI.Sprite;
    private _isTrailAdded: boolean;
    private _noMoreTrail: boolean;

    constructor(symName: string, reelId: number, state?: ISymbolStateConfig) {
        super(symName, reelId, state);
        this.name = "W";
    }

    public setVisibility(value: boolean): void {
        if (this.visible === value) {
            return;
        }
        super.setVisibility(value);

        if (this.visible && this._isTrailAdded) {
            this.playTrailOverlay();
        } else {
            this.resetTrailOverlay(0, false);
        }
    }

    public playTrailOverlay(): void {
        if (this!._noMoreTrail) {
            return;
        }
        this._isTrailAdded = true;

        if (!this.visible) {
            return;
        }
        if (!this._trailOverlay) {
            this._trailOverlay = this.createTrailOverlay();
            this._trailOverlay.y = this.y;
        }
        // To move the patches always on the top.
        if (this._trailOverlay.transform) {
            this.parent.addChild(this);
            this.addChild(this._trailOverlay);
            this._trailOverlay.visible = true;
        }

        // move the current reel to the top of all reels.
        const reelView: PIXI.DisplayObject = this.parent;

        if (reelView.transform && reelView.parent.transform) {
            reelView.parent.addChild(reelView);
        }
    }

    public resetTrailOverlay(duration: number, _noMoreTrail: boolean): TweenLite | null {
        this._isTrailAdded = false;
        this._noMoreTrail = _noMoreTrail;

        if (!this._trailOverlay) {
            return null;
        }

        return TweenLite.to(this._trailOverlay, duration, {
            alpha: 0, onComplete: () => {
                this._trailOverlay.visible = false;
                if (this.parent !== null && this._trailOverlay.parent === this.parent) {
                    this.parent.removeChild(this._trailOverlay);
                }
            }
        });
    }

    protected initState(stateConfig: ISymbolStateConfig): boolean {
        if (super.initState(stateConfig)) {
            // To move the patches always on the top.
            if (this._trailOverlay) {
                this.addChild(this._trailOverlay);
            }

            return true;
        }

        return false;
    }

    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        if (newState.state.keyword === HorribleHeroesGameConfig.instance.SYMBOL_STATES.normal.keyword) {
            this.resetTrailOverlay(0.1, true);
        }
    }

    protected reset(remove: boolean): void {
        this.resetTrailOverlay(0, false);
        super.reset(remove);
    }

    private createTrailOverlay(): PIXI.Sprite {
        const fire: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("WildTrail")[0]);
        fire.anchor.set(0.5);
        fire.scale.set(1);
        fire.blendMode = PIXI.BLEND_MODES.ADD;
        fire.name = "WildTrail";
        return fire;
    }
}